module.exports = __webpack_public_path__ + "img/landing-register.771a119e.jpg";